import { InstructionType } from 'app/src/engine/Instruction';
import { createContext, useContext } from 'react';

type ProgramStoreContext = {
	program: InstructionType[];
	setProgram: (program: InstructionType[]) => void;
	addInstruction: (type: InstructionType, index?: number) => void;
	removeInstruction: (index: number) => void;
	reorderInstruction: (from: number, to: number) => void;
	clearInstructions: () => void;
};

const context = createContext<ProgramStoreContext | null>(null);

export function useProgramStoreContext(): ProgramStoreContext {
	const contextValue = useContext(context);

	if (contextValue === null) {
		throw new Error('useProgramStoreContext must be used within a ProgramStoreContextProvider');
	}

	return contextValue;
}

export const ProgramStoreContextConsumer = context.Consumer;
export const ProgramStoreContextProvider = context.Provider;
